<div class="col-md-12">
    <div class="tab-pane" role="tabpanel" id="formulario33">
        <fieldset id="agregar_formulari33" class="">
            <div class="container" id="center_div">
                <div class="row">
                    <div class="col-md-12">
                        <div id='page1' class="contenedorFormulario print-wrap page1">
                            <div>
                                <span style="float: right; clear: right;">S.P.REC.ART. 5.1.4.N°° 6.1.1. y 6.1.2. </span> Formulario 8.1
                                <span style="float: right; clear: right;">1/3</span>
                            </div>
                            <h1><strong>SOLICITUD DE PERMISO DE RECONSTRUCCION DE EDIFICACIÓN </strong></h1>
                            <h1><strong>DAÑADA A CONSECUENCIA DE UNA CATASTROFE </strong></h1>
                            <div style="text-align: center"><span>Nota: Tener presente plazos establecidos en art. 5.1.4. inciso 2° de OGUC, para poder acogerse a procedimientos simplificados. </span></div>
                            <br />
                            <br />
                            <div class="col-md-12">
                                <table>
                                    <tr>
                                        <td class="col-md-1"></td>
                                        <td class="col-md-5">
                                            <table>
                                                <tr>
                                                    <td><input disabled class="form-check-inline encab" type="checkbox" name="obra" id="obra" [(ngModel)]="tipo_autorizacion[0].autorizacion['DEMOLICION']" /></td>
                                                    <td><label class="titleBox" for="optradio">RECONSTRUCCION DE VIVIENDA</label> <span class="letraChica">(Art. 5.1.4. N° 6.1.1. )</span> </td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td class="col-md-5">
                                            <table>
                                                <tr>
                                                    <td><input disabled class="form-check-inline encab" type="checkbox" name="obra" id="obra" [(ngModel)]="tipo_autorizacion[0].autorizacion['OBRA PRELIMINAR']" /></td>
                                                    <td><label class="titleBox" for="optradio">RECONSTRUCCION  OTROS DESTINOS</label><span class="letraChica">(Art. 5.1.4. N° 6.1.2.)</span> </td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td class="col-md-1"></td>
                                    </tr>
                                </table>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    &nbsp;
                                </div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                    <table class="tablaConBorde">
                                        <tr>
                                            <td>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" [checked]="propiedad[0].ubicacion == 'URBANO'" />
                                                <label for="tpradio">URBANO</label>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" [checked]="propiedad[0].ubicacion == 'RURAL'" />
                                                <label for="tpradio">RURAL</label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td class="letraChica">
                                                    * A LLENAR POR LA D.O.M
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <br>
                            <div>
                                <div class="tituloSeccion">
                                    <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                    <span class="help-block"></span>
                                </div>
                                <table style="width: 100%" border="0" class="tablaConBorde table">
                                    <tr class="fondoResaltado">
                                        <td style="width: 57%" colspan="3">
                                            CALLE O CAMINO
                                        </td>
                                        <td style="width: 24%">
                                            N&Uacute;MERO
                                        </td>
                                        <td style="width: 19%">
                                            ROL SII
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 11%">
                                            MANZANA
                                        </td>
                                        <td style="width: 10%">
                                            LOTE
                                        </td>
                                        <td style="width: 61%" colspan="2">
                                            LOTEO O LOCALIDAD
                                        </td>
                                        <td style="width: 18%">
                                            PLANO DE LOTEO N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].lote" />
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].loteo_numero" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>2.- DECLARACION JURADA</span>
                                    <span class="help-block"></span>
                                </div>

                                <table style="width: 100%;" class="tablaConBordeExterno table">
                                    <tr>
                                        <td colspan="7"><input disabled class="form-control" id="nombre" name="nombre" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td align="right" colspan="4"><span>C&Eacute;DULA DE</span></td>

                                    </tr>
                                    <tr>
                                        <td align="left"><span>IDENTIDAD Nº</span></td>
                                        <td colspan="5"><input disabled class="form-control" id="rut" name="rut" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                        <td colspan="5" align="right"><span>DECLARA BAJO SU RESPONSABILIDAD</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span> SER</span></td>
                                        <td align="left"><span>PROPIETARIO</span></td>
                                        <td colspan="3" align="center"><span>(O  REPRESENTANTE  LEGAL  DEL  PROPIETARIO)</span> </td>
                                        <td colspan="2"><span>DEL  BIEN  RAIZ</span></td>
                                        <td align="left" colspan="4"><span>UBICADO  EN  CALLE/ </span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>/AVENIDA/CAMINO</span></td>
                                        <td align="right" colspan="3"><input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propietarios[0].direccion" /></td>
                                        <td align="left" colspan="3"><span>NUMERO:</span> </td>
                                        <td align="left" colspan="4"><input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propietarios[0].direccion_num" /></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>ROL DE AVALUO Nº</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" /></td>
                                        <td align="left"> <span>DE LA COMUNA DE </span></td>
                                        <td align="right" colspan="7"><input disabled class="form-control" id="comuna" name="comuna" [(ngModel)]="propietarios[0].comuna" type="text" /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" align="left"><span>QUE SE ENCUENTRA INSCRITO A FOJAS</span></td>
                                        <td align="right"><input disabled class="form-control" id="inscripcion" name="inscripcion" type="text" [(ngModel)]="registro_bienes[0].inscrito" /></td>
                                        <td align="center"><span>N°</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="num_insc" name="num_insc" type="text" [(ngModel)]="registro_bienes[0].numero" /></td>
                                        <td align="center"><span>AÑO</span></td>
                                        <td align="right"><input disabled class="form-control" id="anio_insc" name="anio_insc" type="text" [(ngModel)]="registro_bienes[0].anio" /></td>
                                        <td colspan="3" align="left"><span>DEL REGISTRO</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left">DE PROPIEDAD</td>
                                        <td colspan="2" align="left"> DEL CONSERVADOR</td>
                                        <td align="left"> DE BIENES </td>
                                        <td align="left"> RAÍCES DE</td>
                                        <td align="left" colspan="6"><input disabled class="form-control" id="bienes" name="bienes" type="text" [(ngModel)]="registro_bienes[0].bienes" /></td>

                                    </tr>
                                    <tr>
                                        <td align="left">EN EL CUAL</td>
                                        <td align="left">SE EMPLAZA</td>
                                        <td colspan="2" align="left"><span>EL PROYECTO</span></td>
                                        <td align="left"><span>PARA EL QUE SE</span></td>
                                        <td colspan="6" align="left"><span>PRESENTA ESTA SOLICITUD</span></td>
                                    </tr>
                                </table>
                            </div>

                            <div>
                                <div class="tituloSeccion">
                                    <span>3.- DATOS DEL PROPIETARIO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE O RAZ&Oacute;N SOCIAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA DEL PROPIETARIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                        </td>
                                        <td rowspan="7">

                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            REPRESENTANTE LEGAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%" align="left">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado" align="left">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado tablaConBordeExterno table">
                                        <td colspan="4" align="left">
                                            PERSONERIA DEL REPRESENTANTE LEGAL
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            SE ACREDITA MEDIANTE
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            DE FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                        </td>
                                        <td>
                                            Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            ANTE EL NOTARIO SR(A)
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>4- PROFESIONAL COMPETENTE QUE SUSCRIBE SOLICITUD (ARQUITECTO)</span><span class="letraChica">En los cargos que no existe en la DOM los documentos del expediente de la edificación que se reconstruye.</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            <span>NOMBRE O RAZÓN SOCIAL DE LA EMPRESA (cuando corresponda)</span>
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                        <td style="width: 15%">
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 65%">
                                            <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                        </td>
                                        <td rowspan="5" style="width: 15%"></td>

                                    </tr>
                                    <tr class=" fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE ARQUITECTO
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="profesionalComp[0].nombre" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="profesionalComp[0].rut" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 30%" class="fondoResaltado">
                                            N°
                                        </td>
                                        <td style="width: 20%" class="fondoResaltado">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="profesionalComp[0].direccion" />
                                        </td>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="profesionalComp[0].direccion_num" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="profesionalComp[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            E-MAIL
                                        </td>
                                        <td class="fondoResaltado" style="width: 30%">
                                            TEL&Eacute;FONO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FAX
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="profesionalComp[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="profesionalComp[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="profesionalComp[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="profesionalComp[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <br>
                                <div class="tituloSeccion">
                                    <span>5.- PROFESIONAL COMPETENTE A CARGO DE LAS OBRAS</span><span class="letraChica"> En los casos que exista en la DOM los documentos del expediente de la edificación que se reconstruye o que el constructor sea distinto al proyectista.</span>
                                    <span class="help-block"></span>
                                </div>
                                <div>
                                    <table class="tablaConBorde table form-group clone1">
                                        <tr class="fondoResaltado">
                                            <td colspan="2" style="width: 65%" align="left">
                                                <span>NOMBRE O RAZÓN SOCIAL DE LA EMPRESA (cuando corresponda)</span>
                                            </td>
                                            <td style="width: 20%">
                                                R.U.T.
                                            </td>
                                            <td style="width: 15%">
                                                FIRMA
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" style="width: 65%">
                                                <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                            </td>
                                            <td style="width: 20%">
                                                <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                            </td>
                                            <td rowspan="5" style="width: 15%"></td>

                                        </tr>
                                        <tr class=" fondoResaltado">
                                            <td colspan="2" style="width: 65%" align="left">
                                                NOMBRE DEL PROFESIONAL COMPETENTE
                                            </td>
                                            <td style="width: 20%">
                                                R.U.T.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" style="width: 60%"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="profesionalComp[0].nombre" /></td>
                                            <td style="width: 20%"><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="profesionalComp[0].rut" /></td>
                                        </tr>
                                        <tr>
                                            <td class="fondoResaltado izquierda" style="width: 30%">
                                                DIRECCI&Oacute;N / CALLE / PASAJE
                                            </td>
                                            <td style="width: 30%" class="fondoResaltado">
                                                N°
                                            </td>
                                            <td style="width: 20%" class="fondoResaltado">
                                                COMUNA
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="width: 30%">
                                                <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="profesionalComp[0].direccion" />
                                            </td>
                                            <td style="width: 30%">
                                                <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="profesionalComp[0].direccion_num" />
                                            </td>
                                            <td style="width: 20%">
                                                <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="profesionalComp[0].comuna" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="fondoResaltado izquierda" style="width: 30%">
                                                E-MAIL
                                            </td>
                                            <td class="fondoResaltado" style="width: 30%">
                                                TEL&Eacute;FONO
                                            </td>
                                            <td class="fondoResaltado" style="width: 20%">
                                                FAX
                                            </td>
                                            <td class="fondoResaltado" style="width: 20%">
                                                PATENTE PROFESIONAL N°
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="profesionalComp[0].mail" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="profesionalComp[0].fono" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="profesionalComp[0].fax" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="profesionalComp[0].patente" />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div id='page2' class="contenedorFormulario print-wrap page2">
                            <div>
                                <span style="float: right; clear: right;">S.P.REC.ART. 5.1.4.N°° 6.1.1. y 6.1.2. </span> Formulario 8.1
                                <span style="float: right; clear: right;">2/3</span>
                            </div>
                            <div class="tituloSeccion">
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td rowspan="2" style="text-align: left; vertical-align: middle">6.- IDENTIFICACIÓN DEL N° PERMISO Y DE LA RECEPCIÓN DEFINITIVA DE LA OBRA A RECONSTRUIR.<span class="letraChica">En los casos que el expediente se encuentre archivado en la DOM</span></td>
                                        <td>N° PERMISO/AÑO</td>
                                        <td>N° RECEP/AÑO</td>
                                    </tr>
                                    <tr>
                                        <td><input disabled class="form-control" id="numPerm" name="numPerm" type="text" /></td>
                                        <td><input disabled class="form-control" id="numRecep" name="numRecep" type="text" /></td>
                                    </tr>
                                </table>
                            </div>
                            <br>
                            <div class="tituloSeccion">
                                <span>7.- ANTECEDENTES DE LA EDIFICACIÓN A RECONSTRUIR </span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group clone1">
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="vertical-align: middle">SUPERFICIE EDIFICADA (m²)</td>
                                    <td style="vertical-align: middle">SUPERFICIE PARCIAL O TOTAL A RECONSTRUIR (m²)</td>
                                    <td style="vertical-align: middle">SUPERFICIE TOTAL TERRENO (m²)</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; vertical-align: middle">1° Piso</td>
                                    <td style="width: 30%"><input disabled class="form-control" id="supEdi1" name="supEdi1" type="text" /></td>
                                    <td style="width: 25%"><input disabled class="form-control" id="supPar1" name="supPar1" type="text" /></td>
                                    <td rowspan="7" style="width: 25%"><input style="width: 100%; height: 100%" disabled class="form-control" id="supTotal1" name="supTotal1" type="text" /></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle">2° Piso</td>
                                    <td><input disabled class="form-control" id="supEdi2" name="supEdi2" type="text" /></td>
                                    <td><input disabled class="form-control" id="supPar2" name="supPar2" type="text" /></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle">3° Piso</td>
                                    <td><input disabled class="form-control" id="supEdi3" name="supEdi3" type="text" /></td>
                                    <td><input disabled class="form-control" id="supPar3" name="supPar3" type="text" /></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle">4° Piso</td>
                                    <td><input disabled class="form-control" id="supEdi4" name="supEdi4" type="text" /></td>
                                    <td><input disabled class="form-control" id="supPar4" name="supPar4" type="text" /></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle">5° Piso</td>
                                    <td><input disabled class="form-control" id="supEdi5" name="supEdi5" type="text" /></td>
                                    <td><input disabled class="form-control" id="supPar5" name="supPar5" type="text" /></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle">6° Piso</td>
                                    <td><input disabled class="form-control" id="supEdi6" name="supEdi6" type="text" /></td>
                                    <td><input disabled class="form-control" id="supPar6" name="supPar6" type="text" /></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle">7° Piso</td>
                                    <td><input disabled class="form-control" id="supEdi7" name="supEdi7" type="text" /></td>
                                    <td><input disabled class="form-control" id="supPar7" name="supPar7" type="text" /></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle">Total</td>
                                    <td><input disabled class="form-control" id="supEdiT" name="supEdiT" type="text" /></td>
                                    <td><input disabled class="form-control" id="supParT" name="supParT" type="text" /></td>
                                    <td><input disabled class="form-control" id="supTotalT" name="supTotalT" type="text" /></td>
                                </tr>
                                <tr>
                                    <td colspan="4">Nota: En caso que la edificación a reconstruir tenga más pisos, adjuntar esta misma hoja indicando los pisos faltantes.</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="fondoResaltado" align="left">DESTINO DE LA EDIFICACIÓN <span>( En caso de no ser vivienda)</span></td>
                                    <td colspan="2" ></td>
                                </tr>
                                <tr>
                                    <td colspan="4" class="fondoResaltado" align="left">DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO</td>
                                </tr>
                            </table>
                            <table>
                                <tr>
                                    <td style="width: 20%"><input class="doc" type="checkbox" name="tpradio" id="tpradio"/> D.F.L N°2 de 1959</td>
                                    <td style="width: 50%"><input class="doc" type="checkbox" name="tpradio" id="tpradio"/> Ley N° 19.537 Copropiedad Inmobiliaria (Posterior al otorgamiento del permiso)</td>
                                    <td style="width: 30%"><input class="doc" type="checkbox" name="tpradio" id="tpradio"/> Segunda Vivienda Art. 6.2.4. OGUC</td>
                                </tr>
                            </table>
                            <table>
                                <tr>
                                    <td style="width: 30%;"><input class="doc" type="checkbox" name="tpradio" id="tpradio"/> Carácter Vivienda Social (D.L. N°2552 de 1979)</td>
                                    <td style="width: 20%;"><input class="doc" type="checkbox" name="tpradio" id="tpradio"/> Otros (especificar)</td>
                                    <td style="width: 50%;"></td>
                                </tr>
                            </table>
                            <br>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td></td>
                                    <td style="text-align: left">ANTECEDENTES QUE SE ACOMPAÑAN ( Art. 5.1.4. N° 4 )</td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle; width: 3%" align="center"><input disabled class="doc" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                    <td style="vertical-align: middle">Plano de emplazamiento edificación existente con graficación parte a demoler</td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle" align="center"><input disabled class="doc" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                    <td style="vertical-align: middle">Informe del profesional competente en caso de pareo </td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle" align="center"><input disabled class="doc" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                    <td style="vertical-align: middle">Presupuesto de la demolición </td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle; width: 3%" align="center"><input disabled class="doc" type="checkbox" name="tpradio" id="tpradio" /></td>
                                    <td style="vertical-align: middle">Certificado de desratización ( en caso de demolición completa )</td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: middle" align="center"><input disabled class="doc" type="checkbox" name="tpradio" id="tpradio" /></td>
                                    <td style="vertical-align: middle">Informe favorable de la SEREMI MINVU respectiva o del Consejo Monumentos Nacionales ( En caso de inmuebles de conservacion histórica o emplazados en zonas de tal denominación o Monumentos Nacionales)</td>
                                </tr>
                            </table>
                            <div class="tituloSeccion">
                                <span>7.- MONTO A CONSIGNAR AL INGRESO</span><span class="letraChica">( A LLENAR POR LA D.O.M.)</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado" style="text-align: left; vertical-align: middle">PRESUPUESTO DE LA OBRA</td>
                                    <td><input disabled class="form-control" id="monto" name="monto" type="text" value="$" /></td>
                                    <td class="fondoResaltado" style="text-align: left; vertical-align: middle">Monto Total Derechos Municipales</td>
                                    <td><input disabled class="form-control" id="monto" name="monto" type="text" value="$" /></td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado" style="text-align: left; vertical-align: middle">PORCENTAJE A CONSIGNAR</td>
                                    <td><input disabled class="form-control" id="monto" name="monto" type="text" value="%" /></td>
                                    <td class="fondoResaltado" style="text-align: left; vertical-align: middle">Monto</td>
                                    <td><input disabled class="form-control" id="monto" name="monto" type="text" value="$" /></td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado" style="text-align: left; vertical-align: middle">GIRO INGRESO MUNICIPAL Nº</td>
                                    <td><input disabled class="form-control" id="monto" name="monto" type="text" /></td>
                                    <td class="fondoResaltado" style="text-align: left; vertical-align: middle">De Fecha</td>
                                    <td><input disabled class="form-control" id="monto" name="monto" type="text" /></td>
                                </tr>
                            </table>
                        </div>
                        <br>
                        <div id='page3' class="contenedorFormulario print-wrap page3">
                            <div>
                                <span style="float: right; clear: right;">S.O.M.-5.1.3.</span> Formulario 8.1
                                <span style="float: right; clear: right;">3/3</span>
                            </div>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <div class="col-md-3"></div>
                            <div class="col-md-6" align="center">
                                <h1><strong>COMPROBANTE DE INGRESO</strong></h1>
                            </div>
                            <div class="col-md-3">
                                <span style="float: right; clear: right;">S.P.REC.ART. 5.1.4.N°° 6.1.1. y 6.1.2.</span>
                            </div>
                            <div class="col-md-12" align="center">
                                <span>SOLICITUD DE PERMISO DE OBRAS PRELIMINARES Y/O DEMOLICION </span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado">MONTO CONSIGNADO AL INGRESO</td>
                                    <td><input disabled class="form-control" id="monto" name="monto" type="text" value="$" /></td>
                                    <td class="fondoResaltado">GIM Nº</td>
                                    <td><input disabled class="form-control" id="monto" name="monto" type="text" /></td>
                                    <td class="fondoResaltado">FECHA</td>
                                    <td><input disabled class="form-control" id="monto" name="monto" type="text" /></td>
                                </tr>
                            </table>
                            <br>
                            <div class="row">
                                <br>
                                <div class="col-md-3">
                                    <table class="tablaConBordeExterno">
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr align="center">
                                            <td>FIRMA FUNCIONARIO.</td>
                                        </tr>
                                        <tr align="center">
                                            <td> Y TIMBRE D.O.M.</td>
                                        </tr>

                                    </table>

                                </div>
                                <br />
                                <div class="col-md-1"></div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 64%;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado" style="width: 20%">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table class="tablaConBorde">
                                    <tr class="fondoResaltado">
                                        <td style="width: 80%">CALLE O CAMINO</td>
                                        <td>N&Uacute;MERO</td>
                                    </tr>
                                    <tr>
                                        <td><input align="10%" class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                        <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                    </tr>
                                </table>
                            </div>
                            <hr />
                            <br />
                            <br />
                            <br />
                            <br />

                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" align="left">
                <button id="pdf-download-link" title="Descargar Formulario 8.1" (click)="captureScreen()">Descargar Formulario 8.1</button>
            </div>

        </fieldset>
    </div>
</div>